import type { FieldDefinition } from '../../../types'
import { formatCurrencyPl, formatPlNumber, parsePlNumber } from '../../numberFormat'

/** Wartości pól liczbowych w extras (JSONB) bywają stringami ("12450", "2.7") - parsujemy do number. */
function asNumber(value: unknown): number | null {
  if (typeof value === 'number') return Number.isNaN(value) ? null : value
  const n = parsePlNumber(String(value))
  return n == null || Number.isNaN(n) ? null : n
}

/**
 * READ-mode text formatter dla prostych typów. RICH_TEXT, FILE, GALLERY mają
 * własne dedykowane *ReadView komponenty -- te nie przechodzą tędy.
 */
export function formatValue(field: FieldDefinition, value: unknown): string {
  if (value === null || value === undefined || value === '') return '—'
  switch (field.fieldType) {
    case 'BOOLEAN':
      return value ? 'Tak' : 'Nie'
    case 'SELECT':
      return field.options.find(o => o.value === value)?.labelPl ?? String(value)
    case 'MULTI_SELECT':
    case 'CHECKBOX_GROUP': {
      if (!Array.isArray(value)) return String(value)
      return value
        .map(v => field.options.find(o => o.value === v)?.labelPl ?? String(v))
        .join(', ')
    }
    case 'NUMBER': {
      const n = asNumber(value)
      return n === null ? String(value) : formatPlNumber(n)
    }
    case 'CURRENCY': {
      const n = asNumber(value)
      return n === null ? String(value) : formatCurrencyPl(n)
    }
    default:
      return String(value)
  }
}
